import { useMutation } from '@tanstack/react-query';
import { GET, GET_CLAIM_ZIPCODE } from '../../../services';

export const useZipcode = ({ reset, getValues }) => {
  const { mutate, isPending } = useMutation({
    mutationFn: async (value) => {
      try {
        const response = await GET(GET_CLAIM_ZIPCODE(value));
        return response.result;
      } catch (error) {
        console.error('Error fetching zipcode:', error);
      }
    },
    onSuccess: (result) => {
      reset({
        ...getValues(),
        ...result,
      });
    },
  });
  return { mutate, loading: isPending };
};
